export default __webpack_public_path__ + "static/media/card1.78c40ac4.png";